<template>
  <div class="jd-scam">
    <span class="jd-scam__icon" aria-hidden="true">🛡</span>
    <span>Hireclap doesn't charge fees for any job offers. Beware of job offer scams.</span>
  </div>
</template>

<script>
export default {
  name: 'JobDetailScamAlert',
};
</script>
